"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var LoadingCircle_exports = {};
__export(LoadingCircle_exports, {
  default: () => LoadingCircle_default
});
module.exports = __toCommonJS(LoadingCircle_exports);
var React = __toESM(require("react"));
var import_styled_components = __toESM(require("styled-components"));
const SvgIcon = ({
  title,
  titleId,
  desc,
  descId,
  iconSize,
  ariaHidden,
  ...props
}) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    ...props,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    color: "currentColor",
    role: "img",
    "aria-labelledby": titleId,
    "aria-describedby": descId
  },
  desc ? /* @__PURE__ */ React.createElement("desc", { id: descId }, desc) : null,
  title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null,
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12 3.0999C7.08466 3.0999 3.09999 7.08457 3.09999 11.9999C3.09999 13.2668 3.36433 14.4703 3.84029 15.5597C3.97296 15.8633 3.83435 16.217 3.5307 16.3497C3.22705 16.4824 2.87334 16.3438 2.74067 16.0401C2.19976 14.8021 1.89999 13.4352 1.89999 11.9999C1.89999 6.42183 6.42192 1.8999 12 1.8999C17.5781 1.8999 22.1 6.42183 22.1 11.9999C22.1 17.578 17.5781 22.0999 12 22.0999C9.72696 22.0999 7.62774 21.3483 5.93965 20.0803C5.67469 19.8813 5.62124 19.5052 5.82025 19.2403C6.01927 18.9753 6.39539 18.9218 6.66034 19.1209C8.14776 20.2381 9.99573 20.8999 12 20.8999C16.9153 20.8999 20.9 16.9152 20.9 11.9999C20.9 7.08457 16.9153 3.0999 12 3.0999Z",
      fill: "currentColor"
    }
  )
);
const SvgLoadingCircle = (0, import_styled_components.default)(SvgIcon)(({ iconSize, color }) => {
  const getIconSize = () => {
    const standardIconSize = {
      s: "17px",
      // 17px small
      m: "20px",
      // 20px medium
      l: "24px",
      // 24px large
      xl: "32px",
      // 32px extraLarge
      inherit: "inherit"
      // inherits size from parent
    };
    return standardIconSize[iconSize];
  };
  return import_styled_components.css`
    width: ${getIconSize()};
    height: ${getIconSize()};
    display: inline-block;
    color: ${color};
  `;
});
var LoadingCircle_default = SvgLoadingCircle;
